import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 9.2h3V19H5zM16.2 13H19v6h-2.8zm-5.6-8h2.8v14h-2.8z"
}), 'BarChartTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/BarChartTwoTone.js
// module id = 2237
// module chunks = 2